import { useEffect, useState } from 'react';
import { useReportBuilderStore } from '../../stores/reportBuilderStore';
import { FolderOpen, Trash, CaretDown, CaretRight, CircleNotch } from '@phosphor-icons/react';

export default function ReportLibrary() {
  const { savedReports, loadSavedReports, loadReport, deleteReport, queryLoading } = useReportBuilderStore();
  const [open, setOpen] = useState(false);
  const [loadingId, setLoadingId] = useState<string | null>(null);

  useEffect(() => { loadSavedReports(); }, [loadSavedReports]);

  const handleLoad = async (id: string) => {
    setLoadingId(id);
    await loadReport(id);
    setLoadingId(null);
  };

  if (savedReports.length === 0) return null;

  return (
    <div className="flex-shrink-0 border-t border-gray-200 bg-white">
      <button onClick={() => setOpen(!open)}
        className="flex w-full items-center gap-1.5 px-4 py-1.5 text-xs font-medium text-gray-500 hover:bg-gray-50">
        {open ? <CaretDown size={12} /> : <CaretRight size={12} />}
        Saved Reports ({savedReports.length})
      </button>

      {open && (
        <div className="flex flex-wrap gap-2 border-t border-gray-100 px-4 py-2">
          {savedReports.map(report => (
            <div key={report.id}
              className="inline-flex items-center gap-2 rounded border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-xs">
              <div className="min-w-0">
                <p className="font-medium text-gray-700 truncate max-w-[160px]">{report.name}</p>
                <p className="text-[10px] text-gray-400">{new Date(report.updatedAt).toLocaleDateString()}</p>
              </div>
              <button onClick={() => handleLoad(report.id)} disabled={queryLoading}
                className="rounded p-0.5 text-blue-500 hover:bg-blue-50 disabled:opacity-40" title="Load">
                {loadingId === report.id ? <CircleNotch size={14} className="animate-spin" /> : <FolderOpen size={14} />}
              </button>
              <button onClick={() => deleteReport(report.id)}
                className="rounded p-0.5 text-gray-400 hover:bg-red-50 hover:text-red-500" title="Delete">
                <Trash size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
